import gql from 'graphql-tag'

//---------------------------- HomePage Queries ---------------------------------

export const homepageQuery = gql`
query homeQuery($alias : JSON, $lang: String, $location: String) {
  homepages (sort: "displayPosition:asc", where : { alias : $alias, kioskLocationCode_contains : $location }, locale: $lang) {
    id
    speech    
    pageName
    locale 
    alias    
    colLength
    desc
    pageType{
      ... on ComponentHomepageNavigation{
        __typename
        pathName
        pageHeader
      }
      ... on ComponentHomepageDialogBox{
        __typename
        type
        media{
          id
          url
        }
        textList
        mapName      
      }
    }
    displayIcon{
      id
      url
    }
  }
}
`

//---------------------------- Faq Page Queries ---------------------------------

export const faqCategoryQuery = gql`
query faqCategoryQuery($lang: String, $location: String, $category: String) {
  faqCategories(sort: "displayOrder:asc", locale: $lang, where : { courtLocationCode_contains : $location, categoryName : $category}) {
    id
    categoryName
    displayType
    displayOrder
    locale
  }
}
`

export const faqQuery = gql`
query faqQuery($lang: String,  $location: String) {
  faqs (start: 0, locale: $lang, where : { courtLocationCode_contains : $location}) {
    id
    category
    locale
    showmap
    mapName
    showUrl
    urlDetails
    linkId
    question
    answer
  }
}
`

export const faqQuery2 = gql`
query faqQuery($lang: String,  $location: String) {
  faqs (start: 100, locale: $lang, where : { courtLocationCode_contains : $location}) {
    id
    category
    locale
    showmap
    mapName
    showUrl
    urlDetails
    linkId
    question
    answer
  }
}
`

export const faqQuery3 = gql`
query faqQuery($lang: String) {
  faqs (start: 200, locale: $lang, where : { courtLocationCode_contains : $location}) {
    id
    category
    locale
    showmap
    mapName
    showUrl
    urlDetails
    linkId
    question
    answer
  }
}
`
//---------------------------- Map Page Queries ---------------------------------

export const floorQuery = gql`
query floorQuery($lang: String, $location: String) {
  floors (sort : "floorNumber:ASC", locale: $lang, where : { kioskLocationCode_contains: $location }){ 
    id
    floorName
    floorNumber
    speech
    defaultLocation
    locale
    floorImage {
      id
      url
    }
  }
}
`

export const mapQuery = gql`
query mapQuery($lang: String,  $location: String) {
  maps(sort: "mapFloor:ASC", locale: $lang, where : { kioskLocationCode_contains: $location }){
    id
    mapName
    mapFloor
    speech
    locale
    hearingLocationCode
    displayPosition
    mapImage {
      id
      url
    }
  }
}
`

//---------------------------- Form Page Queries ---------------------------------


export const formCategoryQuery = gql`
query formCategoryQuery ($lang: String) {
  formCategories(sort: "id:asc", locale: $lang) {
    id
    name
    categoryType{
      ... on ComponentFormCategoryTypeCategoryType{
        id
        type
      }
    }
    locale
    categoryId
  }
}
`

export const allFormQuery = gql`
query formQuery ($lang: String) {
  forms(start: 0, sort: "id:asc", locale: $lang) {
    id
    formName
    formCategory
    documentType
    documentUrl
    locale
    document{
      id
      url
    }
  }
}
`
